import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { CartService } from 'src/app/components/shared/services/cart.service';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { WishlistService } from 'src/app/components/shared/services/wishlist.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductDialogComponent } from '../../products/product-dialog/product-dialog.component';
import {  SwiperDirective } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import Swiper from 'swiper';

@Component({
  selector: 'app-product-carousel-three',
  templateUrl: './product-carousel-three.component.html',
  styleUrls: ['./product-carousel-three.component.scss']
})
export class ProductCarouselThreeComponent implements OnInit {
  contentLoaded = false;
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();

 @Input('product') products: Array<Product> = [];
 @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;
 public config: SwiperConfigInterface = {};
 filteredProducts:Product[]=[];

  constructor(private cartService: CartService, private productsService: ProductService, private wishlistService: WishlistService, private dialog: MatDialog, private router: Router) { }
  // @ViewChild(SwiperDirective) directiveRef: SwiperDirective;

  ngOnInit() {
    setTimeout(() => {
      this.contentLoaded = true;
      this.filteredProducts = this.products.filter(product => product.price > 0);
      this.initalizeSwiper();
  
      setTimeout(() => {
        this.updateSwiper(); 
      }, 100); 
  
    }, 3000);
  }
  
  ngAfterViewInit(){
   this.initalizeSwiper();
  }
  private initalizeSwiper(){
    this.config = {
      observer: true,
      observeParents: true,
      slidesPerView: 4,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      initialSlide: 0,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 1
        },
        740: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },


      }
    }
  }
  getProductImageUrl(product: any): string {
    // Check if product.pictures[0] exists and is not empty
    if (product.pictures && product.pictures[0]) {
      return `https://weberp-api.com/images/${product.pictures[0]}`;
    } else {
      return '/assets/images/noimg.jpg';
    }
  }

  private updateSwiper() {
    setTimeout(() => {
      if (this.directiveRef?.swiper()) {
        this.directiveRef.swiper().update();
        this.directiveRef.swiper().updateSlides();
        this.directiveRef.swiper().slideTo(0);
      }
    }, 200); 
  }

  // Add to cart
  public addToCart(product: Product,  quantity: number = 1) {
    this.cartService.addToCart(product,quantity);
    console.log(product, quantity);
  }

  // Add to wishlist
  public addToWishlist(product: Product) {
    this.wishlistService.addToWishlist(product);
 }

  // Add to compare
  public addToCompare(product: Product) {
    this.productsService.addToCompare(product);
 }


public openProductDialog(product){
  let dialogRef = this.dialog.open(ProductDialogComponent, {
      data: product,
      panelClass: 'product-dialog',
  });
  dialogRef.afterClosed().subscribe(product => {
    if(product){
      this.router.navigate(['/products', product.id, product.name]);
    }
  });
}

}
